
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import './../styles/components/HeroSection.css';

import slide1 from '../assets/Construction1.png';
import slide2 from '../assets/Maintenance1.png';
import slide3 from '../assets/interiors.jpg';

const HeroSection = () => {
  const slides = [
  {
    image: slide1,
    heading: 'Bounding Trust Into Concrete Since 2001',
    subheading: 'We transform your four walls into happy spaces for keeping your home’s long lasting value. ',
  },
  {
    image: slide2,
    heading: 'From Solid Foundations to Lasting Comfort',
    subheading: 'From planning to home maintenance, we’ve got you covered.',
  },
  {
    image: slide3,
    heading: 'Beautiful Interiors, Thoughtful Designs',
    subheading: 'From small touches to big changes, always for you',
  },
];
  

  return (
    <section id='main' className="hero-slider">
      <Swiper
        modules={[Autoplay, EffectFade]}
        effect="fade"
        autoplay={{ delay: 4000 }}
        loop
        speed={1000}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="slide"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="slide-content">
                <h2>{slide.heading}</h2>
                <p>{slide.subheading}</p>
                <div className="buttons">
                  
                   <button 
    className="btn-secondary" 
    onClick={() => window.location.href="#services"}
  >Plan with Us</button>
                </div>
                
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default HeroSection;
